import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setRemainingTime, startHomework, unpauseHomework } from '../../../actions/status';

import Skeleton from '../../skeleton';
import Button from '../../button';

export const StartHomeworkButton = ({
    isLoading,
    profileName,
    saveStatus,
    showStartPage,
    status,
    setRemainingTime,
    startHomework,
    unpauseHomework,
    disabled,
}) => {
    return (
        <Skeleton isLoading={isLoading} items={[{ height: 'large' }]} width={88}>
            <Button
                type="tertiary"
                size="small"
                onClick={async () => {
                    localStorage.setItem(`showStartPage-${profileName.toLowerCase()}`, showStartPage);
                    startHomework();
                    unpauseHomework(status, saveStatus);

                    if (!!status.sections) {
                        setRemainingTime(status.sections[0].time);
                    }
                }}
                disabled={disabled}
            >
                {'Inizia'}
            </Button>
        </Skeleton>
    );
};

StartHomeworkButton.propTypes = {
    isLoading: PropTypes.bool,
    profileName: PropTypes.string,
    saveStatus: PropTypes.bool,
    showStartPage: PropTypes.bool,
    status: PropTypes.object,
    setRemainingTime: PropTypes.func,
    startHomework: PropTypes.func,
    unpauseHomework: PropTypes.func,
    disabled: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isLoading: state.homework.status.fetching || state.status.httpStatus.fetching || state.auth.status.fetching,
        profileName: state.application.name,
        saveStatus: state.application.saveStatus,
        showStartPage: state.application.showStartPage,
        status: state.status,
    };
};

const actionCreators = {
    setRemainingTime,
    startHomework,
    unpauseHomework,
};

export default connect(mapStateToProps, actionCreators)(StartHomeworkButton);
